import { objectWithoutProperties as _objectWithoutProperties, slicedToArray as _slicedToArray } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import themes from '../../theming/themes.js';
import React, { memo, useState, useEffect } from 'react';
import withDefaultTheme from '../../hocs/withDefaultTheme.js';
import { ModalContext } from './ModalContext.js';
import ModalContainer from './_ModalContainer.js';
import ModalContent from './_ModalContent.js';
import ModalFooter from './_ModalFooter.js';
import ModalHeader from './_ModalHeader.js';
import ModalOpenButton from './_ModalOpenButton.js';
import ModalOverlay from './_ModalOverlay.js';

var _excluded = ["autoOpen", "children", "containerMaxHeight", "contentMaxHeight", "disabledBackdropClick", "footerContentPosition", "footerPrimaryButtonText", "footerPrimaryRenderButton", "footerSecondaryButtonText", "footerSecondaryRenderButton", "getControl", "hasCloseIcon", "headerText", "headerComponent", "modalContainerStyle", "modalOpenRenderButton", "openButtonText", "size", "theme", "isDirectOpen"];
var Modal = function Modal(_ref) {
  var _ref$autoOpen = _ref.autoOpen,
    autoOpen = _ref$autoOpen === void 0 ? false : _ref$autoOpen,
    children = _ref.children,
    _ref$containerMaxHeig = _ref.containerMaxHeight,
    containerMaxHeight = _ref$containerMaxHeig === void 0 ? '100%' : _ref$containerMaxHeig,
    _ref$contentMaxHeight = _ref.contentMaxHeight,
    contentMaxHeight = _ref$contentMaxHeight === void 0 ? '2000px' : _ref$contentMaxHeight,
    _ref$disabledBackdrop = _ref.disabledBackdropClick,
    disabledBackdropClick = _ref$disabledBackdrop === void 0 ? false : _ref$disabledBackdrop,
    _ref$footerContentPos = _ref.footerContentPosition,
    footerContentPosition = _ref$footerContentPos === void 0 ? 'flex-end' : _ref$footerContentPos,
    _ref$footerPrimaryBut = _ref.footerPrimaryButtonText,
    footerPrimaryButtonText = _ref$footerPrimaryBut === void 0 ? 'Okay' : _ref$footerPrimaryBut,
    footerPrimaryRenderButton = _ref.footerPrimaryRenderButton,
    _ref$footerSecondaryB = _ref.footerSecondaryButtonText,
    footerSecondaryButtonText = _ref$footerSecondaryB === void 0 ? 'Cancel' : _ref$footerSecondaryB,
    footerSecondaryRenderButton = _ref.footerSecondaryRenderButton,
    _ref$getControl = _ref.getControl,
    getControl = _ref$getControl === void 0 ? function () {} : _ref$getControl,
    _ref$hasCloseIcon = _ref.hasCloseIcon,
    hasCloseIcon = _ref$hasCloseIcon === void 0 ? false : _ref$hasCloseIcon,
    _ref$headerText = _ref.headerText,
    headerText = _ref$headerText === void 0 ? '' : _ref$headerText,
    headerComponent = _ref.headerComponent,
    modalContainerStyle = _ref.modalContainerStyle,
    modalOpenRenderButton = _ref.modalOpenRenderButton,
    _ref$openButtonText = _ref.openButtonText,
    openButtonText = _ref$openButtonText === void 0 ? '' : _ref$openButtonText,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'medium' : _ref$size,
    _ref$theme = _ref.theme,
    theme = _ref$theme === void 0 ? themes["default"] : _ref$theme,
    _ref$isDirectOpen = _ref.isDirectOpen,
    isDirectOpen = _ref$isDirectOpen === void 0 ? null : _ref$isDirectOpen,
    rest = _objectWithoutProperties(_ref, _excluded);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isOpen = _useState2[0],
    setIsOpen = _useState2[1];
  useEffect(function () {
    setIsOpen(autoOpen);
    getControl(setIsOpen);
  }, []);
  useEffect(function () {
    if (isDirectOpen !== null) {
      setIsOpen(isDirectOpen);
    }
  }, [isDirectOpen]);
  var context = {
    containerMaxHeight: containerMaxHeight,
    contentMaxHeight: contentMaxHeight,
    disabledBackdropClick: disabledBackdropClick,
    footerPrimaryButtonText: footerPrimaryButtonText,
    footerSecondaryButtonText: footerSecondaryButtonText,
    hasCloseIcon: hasCloseIcon,
    headerText: headerText,
    headerComponent: headerComponent,
    hideModal: function hideModal() {
      return setIsOpen(false);
    },
    isOpen: isOpen,
    openButtonText: openButtonText,
    setIsOpen: setIsOpen,
    showModal: function showModal() {
      return setIsOpen(true);
    },
    size: size,
    theme: theme
  };
  return /*#__PURE__*/React.createElement(ModalContext.Provider, {
    value: context
  }, modalOpenRenderButton || openButtonText ? /*#__PURE__*/React.createElement(ModalOpenButton, {
    modalOpenRenderButton: modalOpenRenderButton
  }) : null, /*#__PURE__*/React.createElement(ModalOverlay, rest, /*#__PURE__*/React.createElement(ModalContainer, {
    style: modalContainerStyle
  }, /*#__PURE__*/React.createElement(ModalHeader, {
    hasCloseIcon: hasCloseIcon,
    headerText: headerText,
    headerComponent: headerComponent
  }), /*#__PURE__*/React.createElement(ModalContent, null, children), /*#__PURE__*/React.createElement(ModalFooter, {
    footerPrimaryRenderButton: footerPrimaryRenderButton,
    footerSecondaryRenderButton: footerSecondaryRenderButton,
    footerPrimaryButtonText: footerPrimaryButtonText,
    footerSecondaryButtonText: footerSecondaryButtonText,
    footerContentPosition: footerContentPosition
  }))));
};
var _Modal = withDefaultTheme( /*#__PURE__*/memo(Modal));

export default _Modal;
export { Modal };
